<template>
    <div class="catalog-type">
        <div class="select-box3" :class="{filter: isFilter}">
            <el-popover
                    v-if="navTypesData.length"
                    placement="left"
                    width="508"
                    trigger="hover"
                    v-model="visible"
            >
                <Catalogs
                    v-if="navTypesData"
                    :isShop.sync="isShop"
                    :data="navTypesData"
                    :selectCatalog.sync="newSelectCatalog"
                    @onCatalogs="visible=false"
                    @success="visible = false"
                />
                <div slot="reference" class="more">
                    <img class="img ot" :src="$images.material.catalogMore" alt="img" />
                    <img class="img cur" :src="$images.material.catalogMore1" alt="img" />
                </div>
            </el-popover>
            <el-select
                    v-if="isFilter"
                    class="newFilterValue filter-box"
                    v-model="newFilterValue"
                    placeholder="请选择"
                    size="small"
                    :filterable="true"
                    @change="handleClickChangeFilter(newFilterValue)"
                    @clear.native.stop="handlerClear"
            >
                <el-option
                        v-for="item in filterOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
            <!--clearable-->
            <el-select
                    class="select-box"
                    v-model="value"
                    placeholder="请选择"
                    size="small"
                    :filterable="true"
                    @change="handleClickChange(value)"
                    @clear="handlerClear"
            >
                <el-option
                        v-for="item in newOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <span v-if="warnInfo" class="warn-box">
            {{warnInfo}}
            <span class="close el-icon-error"
                  @click="newSelectCatalog = value"
            ></span>
        </span>
    </div>
</template>

<script>

    import Catalogs from './components/catalogs'
    export default {
        name: "catalog-type",
        components: {
            Catalogs
        },
        props: {
            navTypes: Array,
            form: Array,
            selected: [Number, String, Array],
            filterValue: [Number, String, Array],
            type:String,
            catalogData: Array,
            selectCatalog: [String, Number],
            isShop: Boolean,
            isFilter: Boolean
        },
        computed: {
            filterOptions(){
                let typeData=[];
                if(this.practiceBool()){
                    typeData=[
                        {value: 'is_exercise', label: '课后练习'}
                    ];
                }else{
                    typeData=[
                            {value: '', label: '全部'},
                            {value: 'is_online', label: '线上直播'},
                            {value: 'is_offline', label: '线下白板'},
                            {value: 'is_double_teacher', label: '线下答题器'},
                        ];
                }
                return typeData;
            },
            // 子级筛选 - 面包屑
            warnInfo(){
                let str = ''
                const data = this.$_.cloneDeepWith(this.navTypes)
                const temp = this.$utils.getParentNode(data, this.selectCatalog)
                const isToolsOrGame = ['tools', 'game'].includes(this.type)
                if(isToolsOrGame){
                    if(temp && temp.length>1){
                        str = temp.map(v=>v.name).join('>')
                    }
                } else if(temp && temp.length>2){
                    str = temp.slice(1).map(v=>v.name).join('>')
                }
                return str
            },
            navTypesData(){
                let arr = []
                const value = this.value
                const navTypes = this.$_.cloneDeepWith(this.navTypes)
                if(value && navTypes.length){
                    navTypes.forEach(v=>{
                        if(`${v.id}` === `${value}` && v.childrens.length){
                            arr = v.childrens
                        }
                    })
                }
                return arr
            },
            newOptions(){
                let arr = []
                const data = this.$_.cloneDeepWith(this.navTypes)
                try {
                    arr = this.$utils.oldTree2NewTree({
                        data,
                        oldKeys:['childrens', 'id', 'name'],
                        newKeys: ['children', 'value', 'label']
                    })
                } catch (e) {
                    console.log('获取newOptions失败==>', e)
                }
                return arr
            },
        },
        watch:{
            navTypes(){
                this.value = ''
                this.newSelectCatalog = ''
            },
            form(vl){this.options = vl},
            options(vl){this.$emit('update:form',vl)},
            selected(vl){this.value = vl},
            value(vl){this.$emit('update:selected',vl)},
            isShop(vl){this.newIsShop = vl},
            newIsShop(vl){this.$emit('update:isShop',vl)},
            filterValue(vl){this.newFilterValue = vl},
            newFilterValue(vl){this.$emit('update:filterValue',vl)},
            selectCatalog:{
                handler(vl) {
                    this.newSelectCatalog = vl
                    if (!vl && !['tools', 'game'].includes(this.type)) {
                        this.value = ''
                        this.newSelectCatalog = ''
                    }
                },
                deep: true,
                immediate: true
            },
            newSelectCatalog:{
                handler(vl) {
                    this.$emit('update:selectCatalog', vl)
                    if (!vl && !['tools', 'game'].includes(this.type)) {
                        this.value = ''
                        this.newSelectCatalog = ''
                    }
                },
                deep: true,
                immediate: true
            },
        },
        data(){
            return {
                newIsShop: this.isShop,
                options: this.form,
                value: this.selected,
                newFilterValue: this.filterValue,
                visible: false,
                newSelectCatalog: this.selectCatalog, // 目录选中
            }
        },
        created(){
            if(this.practiceBool()){
                this.newFilterValue='is_exercise';
            }
        },
        methods: {
            practiceBool(){
                return `${this.$route.query.is_practice}` === 'true'
            },
            handleClickChange(value){
                const div = document.querySelector('.content-txt')
                div.scrollTop = 0
                this.newSelectCatalog = value
                this.$emit('onTimesType', value)
                
                if(value === ''){
                    setImmediate(()=>{
                        this.$emit('flashData', true)
                    })
                }
            },
            handleClickChangeFilter(value){
                this.newFilterValue = value
                this.$emit('onFilterChange', value)
            },
            handlerClear(){
                this.newSelectCatalog = ''
                this.newFilterValue = ''
            },
            clearValue(){
                this.value = ''
            }
        }
    }
</script>
<style lang="scss" scoped>
    .catalog-type{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin-bottom: 10px;

        .select-box3 {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;

            &.filter {
                .filter-box {
                    width: 130px !important;

                    & /deep/ .el-input__inner {
                        border-top-right-radius: 0px;
                        border-bottom-right-radius: 0px;
                        background-color: #494B54;
                    }
                }
                .select-box{
                    & /deep/ .el-input__inner {
                        border-top-left-radius: 0px;
                        border-bottom-left-radius: 0px;
                    }
                }
            }

            .filter-box{
                width: 130px !important;
            }

            & /deep/ .el-input__inner {
                background-color: #393B42;
                border: 1px solid #393B42 !important;
                color: white !important;
            }

            .more {
                margin-right: 12px;
                position: relative;
                top: 2px;
                cursor: pointer;

                .img {
                    display: none;

                    &.ot {
                        display: inline-block;
                    }

                    &.cur {
                        display: none;
                    }
                }

                &:hover {

                    .ot {
                        display: none;
                    }

                    .cur {
                        display: inline-block;
                    }
                }
            }

            .select-box {
                width: 100%;
            }
        }
        .warn-box{
            width: 256px;
            font-size: 14px;
            font-weight: 400;
            color: #8C8F97;
            line-height: 20px;
            margin-top: 16px;
            position: relative;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;

            .close{
                position: absolute;
                font-size: 12px;
                top: 2px;
                right: 0px;
                width: 12px;
                height: 12px;
                line-height: 12px;
                text-align: center;
                border-radius: 50%;
                color: #c0c4cc;
                cursor: pointer;

                &:hover{
                    opacity: .8;
                }
            }
        }
    }
</style>
